import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  useTheme
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { logout } from "../../../features/auth/authSlice";
import { Stack } from "rsuite";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  DealerProfile,
  JWTDecode,
  GetDealerSettings,
  GetDealerPaymentGateway,
  saveDealerLoggedinGroup,
  TargetPayApi,
  GetDealerOnboardedLocationGroups
} from "../../../utils/UtilTarget";
import { setDealerId } from "../../../features/dealer/dealerSlice";
import { useNavigate } from "react-router-dom";
import { LocationGroups } from "./header.locationGroups";
import { Divider } from "@mui/material";
import { isEmpty } from "../../../utils/Util";
import { useSaveUserPreferencesIfChanged } from "../../../common/UserPreference/hooks/userPreferenceshook";
import { RootState } from "../../../app/store";

const drawerWidth = 240;

const Header = (props: any) => {
  const theme = useTheme(); // Access the theme
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { handleDrawerToggle } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [loggedInUserName, setloggedInUserName] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [groupName, setGroupName] = useState<string>("");
  const [allLocationGroups, setAllLocationGroups] = useState<[]>([]);
  const [selectedLocationGroup, setSelectedLocationGroup] = useState<any>(null);
  const stateDealerId = useAppSelector(
      (state: RootState) => state.dealer.dealerId
    );

  const savePreferenceIfChanged = useSaveUserPreferencesIfChanged();

  useEffect(() => {
    setloggedInUserName(
      JWTDecode(localStorage.getItem("access_token"), "name")
    );
    getCompanyName();

    const fetchData = async () => {
      await getLocationGroups();
      await getDealerLocationGroupName();
    };

    fetchData();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const iconAccount = document.getElementById("iconAccount");
    setAnchorEl(iconAccount);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    //1. Save Preference first
    await savePreferenceIfChanged();

    //2. clear app session
    dispatch(logout());
    dispatch(setDealerId(""));
    localStorage.clear();
    sessionStorage.clear();

    //3. Redirect
    navigate("/");
  };

  async function getCompanyName() {
    setCompanyName(await DealerProfile("companyName"));
  }

  async function getLocationGroups() {
    let data = JSON.parse(localStorage.getItem("dms_location_groups") || "[]");
    let onboardDealerToken = localStorage.getItem("onboardDealer_token");

    if (data.length === 0) {
      if (isEmpty(onboardDealerToken)) {
        await getDealerLocationGroups();
      }
    } else {
      let selectedDealerId = localStorage.getItem("group_dealerId");
      var currentLocationGroup = data.find(
        x => x.companyDealerId == selectedDealerId
      );

      setAllLocationGroups(data);
      setSelectedLocationGroup(currentLocationGroup || null);
    }
  }

  async function getDealerLocationGroupName() {
    let locationGroupName = localStorage.getItem("location_group_name");

    if (!isEmpty(locationGroupName)) {
      setGroupName(locationGroupName.toString());
      return;
    }

    let dmsDealerId = await DealerProfile("everestDmsDealerId");
    let dealerId = await DealerProfile("dealerId");

    if (dmsDealerId === null || dealerId === null) return;

    const res = await TargetPayApi(
      `GetDealerLocationGroups/${dmsDealerId}/${dealerId}`,
      null,
      "get",
      "Dealer"
    );

    if (!isEmpty(res)) {
      var currentLocationGroup = res.find(x => x.companyDealerId === dealerId);
      setGroupName(currentLocationGroup.name.toString());
    } else {
      setGroupName("");
    }
  }

  async function getDealerLocationGroups() {
    let locationGroupId: number = 0;
    let locationGroupName: string = "";

    let everestDmsDealerId = await DealerProfile("everestDmsDealerId");
    let dealerId = await DealerProfile("dealerId");

    // find all locations against the Everest DmsDealerId
    var dealerLocationGroups = await GetDealerOnboardedLocationGroups(
      everestDmsDealerId,
      dealerId
    );

    if (!dealerLocationGroups || dealerLocationGroups.length === 0) {
      return;
    }

    setAllLocationGroups(
      dealerLocationGroups.length > 0 ? dealerLocationGroups : []
    );

    if (dealerLocationGroups && dealerLocationGroups.length > 0) {
      localStorage.setItem(
        "dms_location_groups",
        JSON.stringify(dealerLocationGroups)
      );

      var defaultOnboarding: any = null;
      // Check 0 -> see if any locationGroup is already set in local storage
      // This is the case when the onboarding is completed and we reload the groups to appear
      let storedDealerGroupId = localStorage.getItem("group_dealerId");
      if (storedDealerGroupId) {
        defaultOnboarding = dealerLocationGroups.find(
          (x) => x.companyDealerId == Number(storedDealerGroupId)
        );
      }

      // check 1 -> find Last logged in group
      if (!defaultOnboarding)
        defaultOnboarding = dealerLocationGroups.find(
          (x) => x.isLastLoginGroup
        );

      // check 2 -> find default companyDealer group
      if (!defaultOnboarding)
        defaultOnboarding = dealerLocationGroups.find(
          (x) => x.companyDealerId == dealerId
        );

      // check 3 -> pick the first record if 1st and 2nd checks are failed.
      locationGroupId = defaultOnboarding
        ? defaultOnboarding.locationGroupId
        : dealerLocationGroups[0].locationGroupId;
      locationGroupName = defaultOnboarding
        ? defaultOnboarding.name
        : dealerLocationGroups[0].name;
      dealerId = defaultOnboarding
        ? defaultOnboarding.companyDealerId
        : dealerLocationGroups[0].companyDealerId;

      // set local storage and state
      localStorage.setItem("group_dealerId", dealerId.toString());
      localStorage.setItem("location_group_id", locationGroupId.toString());
      localStorage.setItem("location_group_name", locationGroupName);

      if(stateDealerId && dealerId !== stateDealerId)
      {
        await GetDealerPaymentGateway(dealerId);
        await GetDealerSettings(dealerId);

        window.location.href = "/dashboard/app";
      }

      dispatch(setDealerId(dealerId.toString()));

      var currentLocationGroup = dealerLocationGroups!.find(
        x => x.companyDealerId == dealerId
      );

      setSelectedLocationGroup(currentLocationGroup || null);
    }
  }

  const handleGroupLocationChange = async value => {
    if (value) {
      let _dealearId = value.companyDealerId;
      let _userName = JWTDecode(localStorage.getItem("access_token"), "name");
      let res;
      if (_userName) {
        // Only remember the group if userName is available
        res = await saveDealerLoggedinGroup(value.locationGroupId, _userName);
      } else {
        res = true;
      }

      if (res === true) {
        localStorage.setItem("group_dealerId", _dealearId.toString());
        localStorage.setItem(
          "location_group_id",
          value.locationGroupId.toString()
        );
        localStorage.setItem("location_group_name", value.name.toString());
        setGroupName(value.name.toString());

        dispatch(setDealerId(_dealearId.toString()));
        await GetDealerPaymentGateway(_dealearId);
        await GetDealerSettings(_dealearId);

        // --- Remove access_token param if present ---
        // This is to prevent localStorage clearance before re-render
        const params = new URLSearchParams(window.location.search);

        if (params.has("access_token")) {
          params.delete("access_token");

          const newUrl = params.toString()
            ? `${window.location.pathname}?${params.toString()}`
            : window.location.pathname;

          window.history.replaceState({}, "", newUrl);
        }
        // ------------------------------------

        setTimeout(() => navigate(0), 500);
      }
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` }
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item xs={6} style={{ fontSize: "large" }}>
            {theme.title} {companyName ? ` - ${companyName}` : ""}{" "}
            {groupName ? ` (${groupName})` : ""}
          </Grid>
          <Grid item style={{ flexGrow: "1" }}></Grid>
          <Grid item xs={6}>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              {selectedLocationGroup && allLocationGroups!.length > 0 && (
                <Box display="flex" alignItems="center" sx={{ mr: 1 }}>
                  <LocationGroups
                    currentlocationGroup={selectedLocationGroup}
                    allLocationGroups={allLocationGroups}
                    onGroupLocationChange={handleGroupLocationChange}
                  ></LocationGroups>
                  <Divider
                    orientation="vertical"
                    sx={{ borderColor: "white", mx: 2, minHeight: "50px" }}
                  />
                </Box>
              )}

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleClick}
                style={{ backgroundColor: "transparent" }}
                color="inherit"
              >
                <Typography>Hello, {loggedInUserName}</Typography>
                <KeyboardArrowDownIcon />
                <AccountCircle id="iconAccount" />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ "aria-labelledby": "basic-button" }}
              >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Stack>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
